/* src/app/features/cnae-impedido/listagem/cnae-impedido-listagem.component.scss */
.table-responsive {
  margin-top: 40px;
}
/*# sourceMappingURL=cnae-impedido-listagem.component.css.map */
